'use strict';

const Event = require('./../lib/events');

class Menu {

    constructor() {

        Event.on('click', '[data-toggle-sub-menu]', (event) => {

            event.preventDefault();

            let current = event.currentTarget;
            let currentClassName = 'is-active';

            //  Toggle plus/minus
            current.classList.toggle(currentClassName);

            //  Open/close sub-menu
            current.nextElementSibling.classList.toggle(currentClassName);

            current.closest('.menu-item-has-children, .secondary-menu .menu-item.last').classList.toggle('is-opened');

        });

        Event.on('mouseover', '.menu-item-has-children, .secondary-menu .menu-item.last', () => {
           App.Globals.body.classList.add('menu-mouse-over');
        });

        Event.on('mouseout', '.menu-item-has-children, .secondary-menu .menu-item.last', () => {
            App.Globals.body.classList.remove('menu-mouse-over');
        });

    }

}

module.exports = Menu;
